import { ColumnConfig, TableColumnConfig, TableColumnType } from '@core/models/skeleton.model';
import { APP_PATHS } from './route.constant';

export const COMPANIES_COLUMNS_CONFIG: Array<ColumnConfig> = [
  {
    field: 'companyName',
    label: 'companies.table.companyName',
    width: '35%',
    isAvatar: true,
  },
  {
    field: 'city',
    label: 'companies.table.city',
    width: '30%',
  },
  {
    field: 'country',
    label: 'companies.table.country',
    width: '35%',
  },
];
// This is only used for the skeleton, which ignores the field and label.
export const SERVICES_COLUMNS_CONFIG: Array<ColumnConfig> = [
  {
    field: 'package',
    label: 'locations.table.companyName',
    width: '25%',
  },
  {
    field: 'device',
    label: 'services.columns.device',
    width: '25%',
  },
  {
    field: 'price',
    label: 'services.columns.price',
    width: '25%',
  },
  {
    field: 'createdOn',
    label: 'services.columns.createdOn',
    width: '25%',
  },
];

export const LOCATIONS_COLUMNS_CONFIG: Array<ColumnConfig> = [
  {
    field: 'address',
    label: 'locations.table.companyName',
    width: '25%',
    isCheckbox: true,
  },
  {
    field: 'zipcode',
    label: 'locations.table.zipcode',
    width: '5%',
  },
  {
    field: 'city',
    label: 'locations.table.city',
    width: '20%',
  },
  {
    field: 'installationType',
    label: 'locations.table.installationType',
    width: '20%',
  },
  {
    field: 'installer',
    label: 'locations.table.installer',
    width: '30%',
    isAvatar: true,
  },
];

export const COMPANIES_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  { field: 'partnerName', label: 'companies.table.companyName', width: '30%', bold: true },
  { field: 'partnerType', label: 'companies.table.type', width: '20%' },
  { field: 'partnerCity', label: 'companies.table.city', width: '25%' },
  { field: 'partnerCountry', label: 'companies.table.country', width: '25%' },
];

export const SERVICES_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  { field: 'locationDisplay', label: 'services.columns.location', width: '28%', bold: true },
  { field: 'packageName', label: 'services.columns.package', width: '8%' },
  { field: 'formattedPrice', label: 'services.columns.price', width: '10%' },
  { field: 'term', label: 'services.columns.term', width: '8%' },
  {
    field: 'createdOn',
    label: 'services.columns.createdOn',
    width: '14%',
    type: TableColumnType.Date,
  },
  {
    field: 'activatedOn',
    label: 'services.columns.activatedOn',
    width: '14%',
    type: TableColumnType.Date,
  },
  { field: 'status', label: 'services.columns.status', width: '14%' },
];

export const LOCATIONS_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  { field: 'address', label: 'locations.table.address', width: '30%', bold: true },
  { field: 'locationPostalCode', label: 'locations.table.zipcode', width: '12%' },
  { field: 'locationCity', label: 'locations.table.city', width: '18%' },
  { field: 'locationCountry', label: 'locations.table.country', width: '20%' },
  { field: 'installerName', label: 'locations.table.installer', width: '20%' },
];

export const INSTALLATIONS_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  { field: 'name', label: 'installations.table.name', width: '27%', bold: true },
  { field: 'partnerName', label: 'installations.table.partner', width: '17%' },
  { field: 'profile', label: 'installations.table.profile', width: '20%' },
  {
    field: 'commissioning',
    label: 'installations.table.commissioning',
    width: '16%',
    type: TableColumnType.Tag,
    stateField: 'commissioningState',
  },
  { field: 'lastData', label: 'installations.table.lastData', width: '20%' },
];

export const MIGRATION_FINDINGS_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  { field: 'className', label: 'installations.migrationReport.table.class', width: '22%' },
  {
    field: 'subject',
    label: 'installations.migrationReport.table.subject',
    width: '20%',
    bold: true,
  },
  {
    field: 'severityLabel',
    label: 'installations.migrationReport.table.severity',
    width: '12%',
    type: TableColumnType.Tag,
    stateField: 'severityState',
  },
  {
    field: 'resolutionLabel',
    label: 'installations.migrationReport.table.resolution',
    width: '12%',
    type: TableColumnType.Tag,
    stateField: 'resolutionState',
  },
  { field: 'partner', label: 'installations.migrationReport.table.partner', width: '16%' },
  { field: 'lastSeen', label: 'installations.migrationReport.table.lastSeen', width: '12%' },
];

// The widths leave 8% for the actions column, which declares none.
export const INSTALLATION_DATA_SOURCE_POINT_COLUMNS: TableColumnConfig[] = [
  {
    field: 'role',
    label: 'installations.dataSources.columns.role',
    width: '21%',
    bold: true,
    subtitleField: 'pointName',
  },
  {
    field: 'required',
    label: '',
    width: '10%',
    type: TableColumnType.Tag,
    stateField: 'requiredTag',
    blankWhenEmpty: true,
  },
  { field: 'unit', label: 'installations.dataSources.columns.unit', width: '7%' },
  { field: 'nature', label: 'installations.dataSources.columns.kind', width: '11%' },
  {
    field: 'state',
    label: 'installations.dataSources.columns.status',
    width: '13%',
    type: TableColumnType.Tag,
    stateField: 'stateTag',
  },
  {
    field: 'source',
    label: 'installations.dataSources.columns.source',
    width: '30%',
    type: TableColumnType.Link,
    secondaryField: 'sourceChannel',
    linkFn: row => ['/', APP_PATHS.Devices, row['deviceId'], 'general'],
  },
];

export const STATUS_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  {
    field: 'ldn',
    label: 'status.table.ldn',
    width: '20%',
    bold: true,
    type: TableColumnType.Link,
    linkFn: row => ['/', APP_PATHS.Devices, row['deviceId'], 'alarms'],
  },
  { field: 'locationDisplay', label: 'status.table.location', width: '30%' },
  {
    field: 'startIntervalTime',
    label: 'status.table.start_interval_time',
    width: '25%',
    type: TableColumnType.Date,
  },
  { field: 'translatedStatusName', label: 'status.table.items', width: '25%' },
];

export const FIRMWARE_MANAGEMENT_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  { field: 'deviceLDN', label: 'firmware.devices.table.deviceLDN', width: '20%', bold: true },
  { field: 'deviceType', label: 'firmware.devices.table.deviceType', width: '15%' },
  { field: 'deviceFirmwareVersion', label: 'firmware.devices.table.currentVersion', width: '15%' },
  {
    field: 'firmwareStatus',
    label: 'firmware.devices.table.status',
    width: '15%',
    type: TableColumnType.Tag,
    stateField: 'firmwareStatusState',
  },
  { field: 'customerName', label: 'firmware.devices.table.customer', width: '20%' },
  {
    field: 'lastReadout',
    label: 'firmware.devices.table.lastUpdated',
    width: '15%',
    type: TableColumnType.Date,
  },
];

export const PARTNERSHIPS_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  { field: 'ownerPartnerName', label: 'partnerships.table.owner', width: '22%', bold: true },
  { field: 'guestPartnerName', label: 'partnerships.table.guest', width: '22%' },
  { field: 'partnershipType', label: 'partnerships.table.type', width: '16%' },
  { field: 'status', label: 'partnerships.table.status', width: '12%' },
  {
    field: 'invitedAt',
    label: 'partnerships.table.invitedAt',
    width: '14%',
    type: TableColumnType.Date,
  },
  {
    field: 'reviewDueDate',
    label: 'partnerships.table.endDate',
    width: '14%',
    type: TableColumnType.Date,
  },
];

export const INSTALLATION_GROUPS_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  { field: 'name', label: 'installationGroups.table.name', width: '28%', bold: true },
  { field: 'ownerPartnerName', label: 'installationGroups.table.owner', width: '24%' },
  { field: 'status', label: 'installationGroups.table.status', width: '14%' },
  { field: 'accessVia', label: 'installationGroups.table.accessVia', width: '16%' },
  {
    field: 'createdAt',
    label: 'installationGroups.table.createdAt',
    width: '18%',
    type: TableColumnType.Date,
  },
];

export const COMPANY_USERS_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  { field: 'fullName', label: 'companies.users.columns.name', width: '25%', bold: true },
  { field: 'email', label: 'companies.users.columns.email', width: '25%', muted: true },
  {
    field: 'createdDate',
    label: 'companies.users.columns.activationDate',
    width: '15%',
    type: TableColumnType.Date,
  },
  { field: 'translatedRole', label: 'companies.users.columns.role', width: '15%' },
  { field: 'translatedStatus', label: 'companies.users.columns.status', width: '15%' },
];

export const DEVICES_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  { field: 'deviceLDN', label: 'devices.table.deviceLDN', width: '20%', bold: true },
  { field: 'deviceType', label: 'devices.table.type', width: '20%' },
  { field: 'installationStateLabel', label: 'devices.table.installationStatus', width: '25%' },
  { field: 'connectionStateLabel', label: 'devices.table.status', width: '15%' },
  { field: 'customerName', label: 'devices.table.installer', width: '20%' },
];

export const DEVICES_COLUMNS_CONFIG: Array<ColumnConfig> = [
  {
    field: 'deviceLDN',
    label: 'devices.table.deviceLDN',
    width: '20%',
  },
  {
    field: 'type',
    label: 'devices.table.type',
    width: '15%',
  },
  {
    field: 'deviceInstallationStatus',
    label: 'devices.table.installationStatus',
    width: '15%',
  },
  {
    field: 'devicePollingStatus',
    label: 'devices.table.polling',
    width: '5%',
  },
  {
    field: 'devicestatus',
    label: 'devices.table.status',
    width: '15%',
  },
  {
    field: 'installer',
    label: 'devices.table.installer',
    width: '20%',
    isAvatar: true,
  },
  {
    field: 'zipcodeAndCity',
    label: 'devices.table.zipcodeAndCity',
    width: '20%',
  },
];

export const SHIPMENT_DEVICES_COLUMNS_CONFIG: Array<ColumnConfig> = [
  {
    field: 'deviceLDN',
    label: 'devices.table.deviceLDN',
  },

  {
    field: 'simStatus',
    label: 'devices.table.simStatus',
  },
  {
    field: 'installationStatus',
    label: 'devices.table.installationStatus',
  },
  {
    field: 'customerName',
    label: 'devices.table.customerName',
  },
];

export const SHIPMENTS_COLUMNS_CONFIG: Array<ColumnConfig> = [
  {
    field: 'shipmentFileId',
    label: 'settings.first.content.table.shipmentFileId',
  },
  {
    field: 'fileName',
    label: 'settings.first.content.table.fileName',
  },
  {
    field: 'orderID',
    label: 'settings.first.content.table.orderId',
  },
  {
    field: 'numberOfDevices',
    label: 'settings.first.content.table.devices',
  },
  {
    field: 'numberOfErrors',
    label: 'settings.first.content.table.errors',
  },
  {
    field: 'status',
    label: 'settings.first.content.table.status',
  },
  {
    field: 'uploadDate',
    label: 'settings.first.content.table.uploaded',
  },
];
export const DEVICE_CONFIG_FILES_COLUMN_CONFIG: Array<ColumnConfig> = [
  {
    field: 'fileName',
    label: 'settings.configFiles.content.table.fileName',
    isCheckbox: true,
  },
  {
    field: 'description',
    label: 'settings.configFiles.content.table.description',
  },
  {
    field: 'channelTypeId',
    label: 'settings.deviceConfigFiles.content.table.channelTypeId',
  },
  {
    field: 'category',
    label: 'settings.deviceConfigFiles.content.table.category',
  },
  {
    field: 'deviceType',
    label: 'settings.configFiles.content.table.device',
  },
  {
    field: 'partnerIds',
    label: 'settings.configFiles.content.table.partners',
  },
  {
    field: 'createdOn',
    label: 'settings.configFiles.content.table.uploadedAt',
  },
];

export const INITIAL_CONFIG_FILES_COLUMN_CONFIG: Array<ColumnConfig> = [
  {
    field: 'fileName',
    label: 'settings.configFiles.content.table.fileName',
    isCheckbox: true,
  },
  {
    field: 'description',
    label: 'settings.configFiles.content.table.description',
  },
  {
    field: 'deviceType',
    label: 'settings.configFiles.content.table.device',
  },
  {
    field: 'partnerIds',
    label: 'settings.configFiles.content.table.partners',
  },
  {
    field: 'createdOn',
    label: 'settings.configFiles.content.table.uploadedAt',
  },
];

export const CREATION_LOCATION_COLUMNS_CONFIG: Array<ColumnConfig> = [
  {
    field: 'address',
    label: 'locations.table.address',
  },
  {
    field: 'zipcode',
    label: 'locations.table.zipcode',
  },
  {
    field: 'city',
    label: 'locations.table.city',
  },
  {
    field: 'country',
    label: 'locations.table.country',
  },
  {
    field: 'action',
    label: '',
  },
];

export const STATUS_CULUMNS_CONFIG: Array<ColumnConfig> = [
  {
    field: 'device_id',
    label: 'status.table.device_id',
    width: '20%',
  },
  {
    field: 'location',
    label: 'status.table.location',
    width: '20%',
  },
  {
    field: 'start_interval_time',
    label: 'status.table.start_interval_time',
    width: '15%',
  },
  {
    field: 'end_interval_time',
    label: 'status.table.end_interval_time',
    width: '15%',
  },
  {
    field: 'items',
    label: 'status.table.items',
    width: '5%',
  },
];

export const FIRMWARE_VERSIONS_COLUMNS_CONFIG: Array<ColumnConfig> = [
  {
    field: 'version',
    label: 'firmware.versions.table.version',
    width: '15%',
  },
  {
    field: 'deviceType',
    label: 'firmware.versions.table.deviceType',
    width: '15%',
  },
  {
    field: 'releaseDate',
    label: 'firmware.versions.table.releaseDate',
    width: '15%',
  },
  {
    field: 'description',
    label: 'firmware.versions.table.description',
    width: '35%',
  },
  {
    field: 'fileSize',
    label: 'firmware.versions.table.fileSize',
    width: '10%',
  },
  {
    field: 'isLatest',
    label: 'firmware.versions.table.isLatest',
    width: '10%',
  },
];

export const SHIPMENTS_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  { field: 'shipmentFileId', label: 'settings.first.content.table.shipmentFileId', width: '10%' },
  { field: 'fileName', label: 'settings.first.content.table.fileName', width: '25%', bold: true },
  { field: 'orderID', label: 'settings.first.content.table.orderId', width: '15%' },
  { field: 'numberOfDevices', label: 'settings.first.content.table.devices', width: '10%' },
  { field: 'numberOfErrors', label: 'settings.first.content.table.errors', width: '10%' },
  {
    field: 'status',
    label: 'settings.first.content.table.status',
    width: '15%',
    type: TableColumnType.Tag,
    stateField: 'statusState',
  },
  {
    field: 'uploadDate',
    label: 'settings.first.content.table.uploaded',
    width: '15%',
    type: TableColumnType.Date,
  },
];

export const DEVICE_CONFIG_FILES_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  {
    field: 'fileName',
    label: 'settings.configFiles.content.table.fileName',
    width: '20%',
    bold: true,
  },
  { field: 'description', label: 'settings.configFiles.content.table.description', width: '20%' },
  {
    field: 'channelTypeId',
    label: 'settings.deviceConfigFiles.content.table.channelTypeId',
    width: '10%',
  },
  {
    field: 'categoryName',
    label: 'settings.deviceConfigFiles.content.table.category',
    width: '15%',
  },
  { field: 'deviceType', label: 'settings.configFiles.content.table.device', width: '15%' },
  { field: 'partnerNames', label: 'settings.configFiles.content.table.partners', width: '15%' },
  {
    field: 'createdOn',
    label: 'settings.configFiles.content.table.uploadedAt',
    width: '15%',
    type: TableColumnType.Date,
  },
];

export const INITIAL_CONFIG_FILES_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  {
    field: 'fileName',
    label: 'settings.configFiles.content.table.fileName',
    width: '25%',
    bold: true,
  },
  { field: 'description', label: 'settings.configFiles.content.table.description', width: '25%' },
  { field: 'deviceType', label: 'settings.configFiles.content.table.device', width: '15%' },
  { field: 'partnerNames', label: 'settings.configFiles.content.table.partners', width: '20%' },
  {
    field: 'createdOn',
    label: 'settings.configFiles.content.table.uploadedAt',
    width: '15%',
    type: TableColumnType.Date,
  },
];

export const FIRMWARE_VERSIONS_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  { field: 'version', label: 'firmware.versions.table.version', width: '15%', bold: true },
  { field: 'filename', label: 'firmware.versions.table.filename', width: '25%' },
  {
    field: 'releaseDate',
    label: 'firmware.versions.table.releaseDate',
    width: '10%',
    type: TableColumnType.Date,
  },
  { field: 'title', label: 'firmware.versions.table.description', width: '25%' },
  { field: 'formattedSize', label: 'firmware.versions.table.fileSize', width: '10%' },
  {
    field: 'isActiveStatus',
    label: 'firmware.versions.table.active',
    width: '15%',
    type: TableColumnType.Tag,
    stateField: 'isActiveState',
  },
];

export const FIRMWARE_DEVICES_COLUMNS_CONFIG: Array<ColumnConfig> = [
  {
    field: 'deviceLDN',
    label: 'firmware.devices.table.deviceLDN',
    width: '15%',
    isCheckbox: true,
  },
  {
    field: 'deviceType',
    label: 'firmware.devices.table.deviceType',
    width: '12%',
  },
  {
    field: 'currentFirmwareVersion',
    label: 'firmware.devices.table.currentVersion',
    width: '12%',
  },
  {
    field: 'latestFirmwareVersion',
    label: 'firmware.devices.table.latestVersion',
    width: '12%',
  },
  {
    field: 'firmwareStatus',
    label: 'firmware.devices.table.status',
    width: '12%',
  },
  {
    field: 'customerName',
    label: 'firmware.devices.table.customer',
    width: '20%',
    isAvatar: true,
  },
  {
    field: 'lastUpdated',
    label: 'firmware.devices.table.lastUpdated',
    width: '17%',
  },
];

export const ACTIVITY_TABLE_COLUMNS: TableColumnConfig[] = [
  {
    field: 'action',
    label: 'devices.detailTabs.activity.columns.action',
    width: '15%',
    bold: true,
  },
  {
    field: 'channel_number',
    label: 'devices.detailTabs.activity.columns.channel',
    width: '5%',
    muted: true,
  },
  { field: 'message', label: 'devices.detailTabs.activity.columns.message', width: '35%' },
  {
    field: 'status',
    label: 'devices.detailTabs.activity.columns.status',
    width: '10%',
    type: TableColumnType.Tag,
    stateField: 'statusState',
  },
  {
    field: 'initiated_by',
    label: 'devices.detailTabs.activity.columns.initiated_by',
    width: '15%',
  },
  {
    field: 'initiated_on',
    label: 'devices.detailTabs.activity.columns.initiated_on',
    width: '12%',
  },
];

export const SEARCH_COMPANIES_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  { field: 'partnerName', label: 'search.companies.table.name', width: '35%', bold: true },
];

export const SEARCH_LOCATIONS_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  { field: 'address', label: 'search.locations.table.address', width: '35%', bold: true },
  { field: 'postalCode', label: 'search.locations.table.zipcode', width: '15%' },
  { field: 'locationCity', label: 'search.locations.table.city', width: '25%' },
  { field: 'partnerName', label: 'search.locations.table.installer', width: '25%' },
];

export const SEARCH_INSTALLATIONS_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  { field: 'name', label: 'search.installations.table.name', width: '35%', bold: true },
  { field: 'address', label: 'search.installations.table.address', width: '40%' },
  { field: 'partnerName', label: 'search.installations.table.partner', width: '25%' },
];

export const SEARCH_DEVICES_TABLE_COLUMNS_CONFIG: TableColumnConfig[] = [
  { field: 'deviceName', label: 'search.devices.table.deviceName', width: '40%', bold: true },
  { field: 'deviceType', label: 'search.devices.table.type', width: '20%' },
  { field: 'deviceInstallationStatus', label: 'search.devices.table.status', width: '20%' },
  { field: 'partnerName', label: 'search.devices.table.installer', width: '20%' },
];
